export { default } from './MonthlyHistogramContainerMobile';
